export const SERVER_MESSAGE = {
  SERVER_READY: "server_ready",
  SERVER_READY_FAIL: "server_ready_fail",
  AVATAR_READY: "avatar_ready",
  BROADCAST_ANIMATION: "broadcast_animation",
  SERVER_SCRIPT_EVENT: "server_script_event",
  AVATAR_EMOTE_CHANGED: "avatar_emote_changed",
  AVATAR_MODEL_CHANGED: "avatar_model_changed",
  USERSCRIPT_ERROR: "userscript_error",
};

export const CLIENT_MESSAGE = {
  CREATE_AVATAR: "create_avatar",
  MOVE_INPUT: "move_input",
  KEY_INPUT: "key_input",
  MOUSE_INPUT: "mouse_input",
  SEND_ANIMATION: "send_animation",
  CLIENT_SCRIPT_EVENT: "client_script_event",
  AVATAR_EMOTE_CHANGED: "avatar_emote_changed",
  AVATAR_MODEL_CHANGED: "avatar_model_changed",
  API_RESULT: "api_result",
};

export const RedbrickPrefix = "___m___";

export const USERSCRIPT_LANGUAGE = {
  JAVASCRIPT: "javascript",
  JAVASCRIPT_3D: "javascript-3d",
  BLOCK: "block",
};

export const AVATAR_ANIMATION = {
  IDLE: "IDLE",
  JUMP: "JUMP",
  FALL: "FALL",
  SIT: "SIT",
  GROUND_SIT: "GROUND_SIT",
  WALK: "WALK",
  RUN: "RUN",
  BOOST: "BOOST",
  ATTACK: "ATTACK",
  DIE: "DIE",
  VICTORY: "VICTORY",
  SELFIE: "SELFIE",
  PICK: "PICK",
  DESSERT_EAT: "DESSERT_EAT",
  DESSERT_SMELL: "DESSERT_SMELL",
  HALLOWEEN_BASKET: "HALLOWEEN_BASKET",
  HALLOWEEN_CANDY: "HALLOWEEN_CANDY",
  HALLOWEEN_SCARE: "HALLOWEEN_SCARE",
};

export const AUDIO_STATUS = {
  STOPPED: 0,
  PAUSED: 1,
  PLAYING: 2,
};

export const OBJECT_TYPES = {
  COMMON: "Common",
  COMMON_OBJECT: "CommonObject",
  AVATAR: "Avatar",
  CAMERA: "Camera",
  LIGHT: "Light",
  MESH: "Mesh",
  PORTAL: "Portal",
  SCENE: "Scene",
  SPRITE: "Sprite",
  VIDEO: "Video",
  PARTICLE_SYSTEM: "ParticleSystem",
  AUDIO: "Audio",
  BACKGROUND: "Background",
  MATERIAL: "Material",
  TEXT: "Text",
  TEXTURE: "Texture",
  VECTOR2: "Vector2",
  VECTOR3: "Vector3",
  VECTOR4: "Vector4",
};
